import React from 'react'
import HoldDownQuantity from '../../shared/pu-react/components/pallets/HoldDownQuantity';
import NeedTopHat from '../../shared/pu-react/components/pallets/NeedTopHat';
import NeedStiffenerBar from '../../shared/pu-react/components/pallets/NeedStiffenerBar';
import ThroughHoleQuantity from '../../shared/pu-react/components/pallets/ThroughHoleQuantity';

import {
  holdDowns as holdDownsTooltip,
  topHat as topHatTooltip,
  stiffenerBars as stiffenerBarsTooltip,
  shoulderBolts as shoulderBoltsTooltip
} from '../data/Tooltips'

const Hardware = (props) => {
  const { validator, parameters } = props
  return (
    <div className="hardware-section">
      <h5 className="hardware-title">Hardware</h5>
      <div className="row">
        <div className="col-12">
          <HoldDownQuantity {...props} required={true} tooltip={holdDownsTooltip} label="# of hold downs ($3 each)">
            {validator.message(`Hold Down Quantity`, parameters.hold_down_board_quantity, 'required|integer|min:0,num')}
          </HoldDownQuantity>
        </div>
        <div className="col-12">
          <NeedTopHat {...props} required={true} tooltip={topHatTooltip}>
            {validator.message(`Need Top Hat`, parameters.pallet_need_top_hat, 'required')}
          </NeedTopHat>
        </div>
        <div className="col-12">
          <NeedStiffenerBar {...props} required={true} tooltip={stiffenerBarsTooltip}>
            {validator.message(`Need Stiffener Bars`, parameters.pallet_need_stiffener_bar, 'required')}
          </NeedStiffenerBar>
        </div>
        <div className="col-12">
          <ThroughHoleQuantity {...props} required={true} tooltip={shoulderBoltsTooltip}>
            {validator.message(`Through-Hole quantity`, parameters.through_hole_component_pressed_quantity, 'required|integer|min:0,num')}
          </ThroughHoleQuantity>
        </div>
      </div>
    </div>
  )
}

export default Hardware;
